import astonPic from "@/public/images/artists/aston.png";
import { Artist } from "@/types/types";

export const aston = {
  id: "11",
  name: "Aston",
  image: astonPic,
  description: `Aston is your ultimate punk rock vocalist. With her powerful and gritty voice, she will deliver electrifying performances that resonate with the rebel in you.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Faston-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Punk", "Rock", "Dance", "Pop", "Belting"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 49,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
